'use client';

import { c as _c } from "react/compiler-runtime";
import { TopNavV5AccountPanel } from '@src/components/TopNavV5/TopNavV5AccountPanel/TopNavV5AccountPanel';
import { TopNavV5Provider } from '@src/components/TopNavV5/TopNavV5Context';
import { defaultTopNavV5Props } from './TopNavV5.defaults';
import { TopNavV5Desktop } from './TopNavV5Desktop/TopNavV5Desktop';
import { TopNavV5Mobile } from './TopNavV5Mobile/TopNavV5Mobile';
import { type TopNavV5Props } from './TopNavV5Props';
export const TopNavV5 = t0 => {
  const $ = _c(5);
  const props = t0 === undefined ? defaultTopNavV5Props : t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavV5Mobile />;
    t2 = <TopNavV5Desktop />;
    t3 = <TopNavV5AccountPanel />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props) {
    t4 = <TopNavV5Provider topNavProps={props}>{t1}{t2}{t3}</TopNavV5Provider>;
    $[3] = props;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};